import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreHref?: string;
  moreLabel?: string;
}

export default function SectionHeader({
  title,
  subtitle,
  moreHref,
  moreLabel = "查看全部"
}: SectionHeaderProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="min-w-0">
        <h2 className="flex items-center gap-3 font-heading text-xl font-700 text-foreground-50 md:text-2xl">
          <span className="h-6 w-1 rounded-full bg-accent-500 md:h-7" aria-hidden="true" />
          <span className="truncate">{title}</span>
        </h2>
        {subtitle && (
          <p className="mt-2 pl-4 text-sm text-foreground-400">{subtitle}</p>
        )}
      </div>
      {moreHref && (
        <Link
          to={moreHref}
          className="flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-500 text-secondary-400 transition-colors hover:text-accent-400"
        >
          {moreLabel}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-s-line text-base" aria-hidden="true" />
          </span>
        </Link>
      )}
    </div>
  );
}